module.exports = __webpack_public_path__ + "img/icon-51.d82839e9.png";